























































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ProviderFilter from "@/components/report/filters/Providers.vue";
import StatusFilter from "@/components/report/filters/Status.vue";
import SubStatusFilter from "@/components/report/filters/SubStatus.vue";
import ApptDateFilter from "@/components/report/filters/ApptDate.vue";
import AdmissionDischargeFilter from "@/components/report/filters/AdmissionDischarge.vue";

import moment from "moment";


@Component({
  components: {
    ProviderFilter,
    StatusFilter,
    SubStatusFilter,
    ApptDateFilter,
    AdmissionDischargeFilter
  },
   computed: {

  }
})


export default class StatusSummaryList extends Vue {
  @Prop(Array) readonly items!: Array<any>;
  @Prop(Object) readonly filter!: Object;

  public reportDateTime: string = "";

  get header(){
      return this.items.length>0? Object.keys(this.items[0]):[];
  }

  @Watch("items", { immediate: true, deep: true })
  onItemsChanged(newItems: Array<any>) {
    if (newItems && newItems.length > 0) {
      this.reportDateTime = (this.$moment ? this.$moment() : moment())
        .format("MMM DD YYYY hh:mm A")
        .toUpperCase();
    } else {
      this.reportDateTime = "";
    }
  }

 

}
